module.exports = __webpack_public_path__ + "img/JulieCherrington.9e93cbbc.png";